import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { MDSTypography } from '@marqvision/mds-v2';
import { Desktop } from './responsive/Desktop';
import { TabletMobile } from './responsive/TabletMobile';

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    bottom: 0,
    [theme.breakpoints.down(theme.breakpoint.tablet)]: {
      paddingBottom: 0,
    },
  },
  links: {
    display: 'flex',
    flexDirection: 'row',
    '& a': {
      margin: '0 6px',
      '&:hover': {
        opacity: 0.7,
        textDecoration: 'none',
      },
    },
  },
  footerContent: {
    paddingTop: 5,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
}));

const currentYear = new Date().getFullYear();

export const Footer = (): React.ReactNode => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <Desktop>
        <div className={classes.links}>
          <MDSTypography
            variant="body"
            size="xs"
            weight="regular"
            color="color/content/neutral/secondary/normal"
            as="a"
            href="https://www.marqvision.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Home
          </MDSTypography>
          <MDSTypography
            variant="body"
            size="xs"
            weight="regular"
            color="color/content/neutral/secondary/normal"
            as="a"
            href="https://www.marqvision.com/terms-2103"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms
          </MDSTypography>
          <MDSTypography
            variant="body"
            size="xs"
            weight="regular"
            color="color/content/neutral/secondary/normal"
            as="a"
            href="https://www.marqvision.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </MDSTypography>
          <MDSTypography
            variant="body"
            size="xs"
            weight="regular"
            color="color/content/neutral/secondary/normal"
            as="a"
            href="mailto:contact@marqvision.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact
          </MDSTypography>
        </div>
        <MDSTypography
          variant="body"
          size="m"
          weight="regular"
          color="color/content/neutral/secondary/normal"
          className={classes.footerContent}
        >
          © {currentYear} Marq Vision Inc. All Rights Reserved.
        </MDSTypography>
      </Desktop>
      <TabletMobile></TabletMobile>
    </div>
  );
};
